import * as DialogPrimitive from '@radix-ui/react-dialog';


const DialogClose = DialogPrimitive.Close;

export { DialogClose };
